import React, { Component } from 'react';
import CustomPageHeader from './CustomPageHeader/CustomPageHeader';
import { isLoggedInUserInLocalStorage } from '../../actions/UserActions';
import FixedButtonAddEvent from '../FixedButtonAddEvent/FixedButtonAddEvent';
import './CustomPages.css';
import { GENERAL_STATEMENT, GENERAL_STATEMENT_INTRO_TEXT } from '../../config/TextContent';

class GeneralStatement extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }

    render(){
        return(
            <div className="custom-page">
                {isLoggedInUserInLocalStorage() ? <FixedButtonAddEvent/> : null}
                <CustomPageHeader
                    title={GENERAL_STATEMENT}
                    text={GENERAL_STATEMENT_INTRO_TEXT}
                />
                <div className="custom-page__body">
                    <div className="container">
                        <div className="row custom-page__content">
                            <div className="col-md-12">
                                <p></p>
                                <br/>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}   

export default GeneralStatement;
